export default __webpack_public_path__ + "static/media/fylo.2356dc36.png";